// const accordionLists = document.querySelectorAll('.accordion-list')
//     const accordionItens = document.querySelectorAll('.accordion')
//     const accordionBtns = document.querySelector('.accordion__head')
//     accordionItens.forEach((item) => {
//         const button = item.querySelector('.accordion__head')
//         const body = item.querySelector('.accordion__body')
//         button.addEventListener('click', () => {
//             console.log(body.scrollHeight)
//             itemOpen = button.getAttribute('aria-expanded')
//             if (itemOpen === 'true') {
//                 button.setAttribute('aria-expanded', 'false');
//                 body.style.height = 0
//                 setTimeout(function(){
//                     body.style.display = 'none'
//                 },500)
//             }
//             else {
//                 button.setAttribute('aria-expanded', 'true');
//                 body.style.display = 'block'
//                 body.style.height = body.scrollHeight + 'px'
//             }

// 	    })
        
//     });